import { createLocalStorageProvider } from '@jira/platform__browser-storage-providers/src/controllers/local-storage/index.tsx';

export type ViewMode = 'MODAL' | 'SIDEBAR' | 'DEFAULT';

// The storage key and provider are private to this package. Reads and writes of the issue
// preview-mode preference go exclusively through getViewModeFromLocalStorage and
// setViewModeInLocalStorage, so the key string lives in exactly one place and cannot drift between
// the React context package and the @jira/issue__context-service that also persists this preference.
const localStorage = createLocalStorageProvider('jira_issue_view');
const VIEW_MODE_STORAGE_KEY = 'view-mode';

// Plain localStorage read with no SSR guard. When adopting in the issue view context, wrap the call
// in an SSR-safe guard (e.g. useSsrSafeCallback) to avoid a hydration mismatch.
export const getViewModeFromLocalStorage = (): ViewMode => {
	const stored = localStorage.get(VIEW_MODE_STORAGE_KEY);
	if (stored === 'MODAL' || stored === 'SIDEBAR') {
		return stored;
	}
	return 'DEFAULT';
};

export const setViewModeInLocalStorage = (viewMode: 'MODAL' | 'SIDEBAR'): void => {
	// @browser-storage setter
	localStorage.set(VIEW_MODE_STORAGE_KEY, viewMode);
};
